/**
 * Flags shared by the session commands.
 *
 * @module
 */
import { Flag } from "effect/unstable/cli"

export const dirFlag = Flag.string("dir").pipe(
  Flag.withDescription("Project directory (default: current directory)"),
  Flag.withDefault("."),
)

export const apiUrlFlag = Flag.string("api-url").pipe(
  Flag.withDescription("API base URL override, e.g. http://localhost:3000"),
  Flag.optional,
)

export const jsonFlag = Flag.boolean("json").pipe(
  Flag.withDescription("Emit machine-readable JSON instead of human output"),
)
